export const usePageTitle = (pageTitle: string) => {
  document.title = pageTitle
}
